import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import React from 'react';
import DateField from 'Components/UI/DateField';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    width: '100%',
    minWidth: '150px',
    '& .MuiTextField-root': {
      fontWeight: theme.typography.fontWeightMedium,
    },
    '& .MuiInputBase-root': {
      color: theme.palette.facet.primaryBlue,
      background: theme.palette.facet.accentBlue20,
      fontWeight: theme.typography.fontWeightMedium,
      borderRadius: '16px',
      '& input': {
        alignSelf: 'flex-end',
        padding: theme.spacing(1, 2),
        height: '34px',
      },
    },
    '& .MuiInputLabel-shrink': {
      color: theme.palette.common.black,
      transform: 'translate(12px, 15px) scale(0.75)',
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.facet.primaryBlue,
    },
  },
}));


function LabellessDateField({
  format, placeholder, InputProps, ...rest
}) {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <DateField
      classes={{
        root: classes.root,
      }}
      InputProps={{
        ...InputProps,
        disableUnderline: true,
      }}
      placeholder={placeholder}
      format={format}
      variant={'filled'}
      views={['month', 'year']}
      {...rest}
      label={''}
      helperText={''}
    />
  );
}

LabellessDateField.propTypes = {
  format: 'MM/DD/YYYY',
  placeholder: 'MM/DD/YYYY',
  InputProps: {},
};

LabellessDateField.defaultProps = {
  format: PropTypes.string,
  placeholder: PropTypes.string,
  InputProps: PropTypes.object,
};

export default LabellessDateField;
